import React from 'react';

const About = () => (
  <div
    className="about-page"
    style={{
      maxWidth: '800px',
      margin: '3em auto',
      background: 'var(--cardBackground, #fffbe6)',
      borderRadius: '12px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
      padding: '2.5em',
      color: 'var(--textMain, #222)',
      fontSize: '1.15em',
      lineHeight: 1.7,
    }}
  >
    <h1
      style={{
        color: 'var(--textHeading, #00C135)',
        textAlign: 'center',
        marginBottom: '1em',
      }}
    >
      About TimeLib
    </h1>

    <p>
      At <strong>TimeLib</strong>, we believe that time is not just measured — it's worn, lived, and remembered. That’s why we bring you a bold and curated collection of watches that reflect your personality, ambition, and lifestyle.
    </p>

    <p>
      Whether you're dressing for a business meeting, a casual outing, or a night to remember, TimeLib offers watches that are both stylish and affordable. Every timepiece we sell is handpicked to meet our promise: <strong>Affordable Style, Timeless Quality</strong>.
    </p>

    <p>
      Founded in Liberia, TimeLib was created for everyday individuals who want to express themselves through premium-looking watches without spending a fortune. We serve a new generation of Liberians who value elegance, purpose, and the power of time.
    </p>

    <p>
      <strong>Why shop with TimeLib?</strong>
      <ul>
        <li>✨ Affordable watches that look and feel premium</li>
        <li>🛍️ Smooth, secure, and user-friendly shopping experience</li>
        <li>📦 Fast delivery within Liberia with reliable service</li>
        <li>💬 Real-time support and a commitment to customer satisfaction</li>
      </ul>
    </p>

    <p style={{ textAlign: 'center', marginTop: '2em', color: 'var(--primary, #D4AF37)' }}>
      Thank you for choosing TimeLib. We’re not just selling watches — we’re helping you wear time with pride.
    </p>
  </div>
);

export default About;
